{
  "gunlukisler": {
    "GunlukIsler": "Dagelijkse Taken",
    "Baslik": "Dagelijkse Taken",
    "Yeni İş Ekle": "Nieuwe Taak Toevoegen",
    "İş Detayı": "Taakdetail",
    "İş Bilgisi": "Taakinfo",
    "Tarih": "Datum",
    "Saat": "Tijd",
    "Başlama Saati": "Starttijd",
    "Bitiş Saati": "Eindtijd",
    "Açıklama": "Beschrijving",
    "Açıklama / Not": "Beschrijving / Notitie",
    "Ekle": "Toevoegen",
    "Sil": "Verwijderen",
    "Kapat": "Sluiten",
    "Vazgeç": "Annuleren",
    "Silme Onayı": "Verwijderingsbevestiging",
    "Bu kaydı silmek istediğinize emin misiniz?": "Weet u zeker dat u dit record wilt verwijderen?",
    "Bugün": "Vandaag",
    "Ay": "Maand",
    "Hafta": "Week",
    "Gün": "Dag",
    "Liste": "Lijst",
    "Bilgi": "Info",
    "Data Yenile": "Gegevens Vernieuwen",
    "Güncelle": "Bijwerken",
    "Kayıt başarıyla oluşturuldu.": "Record succesvol aangemaakt.",
    "Kayıt başarıyla güncellendi.": "Record succesvol bijgewerkt.",
    "Kayıt başarıyla silindi.": "Record succesvol verwijderd.",
    "GecmisTarihUyari": "Gegevens met een datum in het verleden kunnen niet worden gewijzigd."
  }
}
